<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

const props = defineProps({
  dialogId: {
    type: String,
    default: "RaceDateSelectDialog",
  },
  title: {
    type: String,
    default: "レース選択",
  },
  date: {
    type: String,
    default: "",
  },
});

const darkModeOn = window.matchMedia("(prefers-color-scheme: dark)").matches;
const boatraceDate = ref(props.date);
const emit = defineEmits(["result"]);
function onClick(emitfunc, resdata) {
  emit(emitfunc, resdata);
}

const openDialog = () => {
  boatraceDate.value = props.date;
};

onMounted(() => {
  let myModalEl = document.getElementById(props.dialogId);
  myModalEl.addEventListener("show.bs.modal", openDialog);
});

onBeforeUnmount(() => {
  let myModalEl = document.getElementById(props.dialogId);
  myModalEl.removeEventListener("show.bs.modal", openDialog);
});
</script>

<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="props.dialogId"
    tabindex="-1"
    aria-labelledby="raceDateModal"
    aria-hidden="true"
    :data-bs-theme="darkModeOn ? 'dark' : 'light'"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="raceDateModalLabel">
            {{ props.title }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="title content_line">
            <div class="item_parent">
              <div class="content_title">
                <div class="texttitle">レース日</div>
              </div>
              <div class="content_item flex-column">
                <div class="d-flex flex-row mt-2">
                  <VueCtkDateTimePicker
                    :button-clear="false"
                    v-model="boatraceDate"
                    format="YYYY-MM-DD"
                    formatted="YYYY年MM月DD日"
                    :no-header="true"
                    :no-button-now="true"
                    :placeholder="'レース日'"
                    no-label
                    no-clear-button
                    auto-close
                    only-date
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex flex-row">
              <button
                type="button"
                class="modal_button submit_button"
                data-bs-dismiss="modal"
                @click="onClick('result', { res: false })"
              >
                キャンセル
              </button>
              <button
                type="button"
                class="modal_button submit_button"
                data-bs-dismiss="modal"
                @click="
                  onClick('result', {
                    res: true,
                    dialogId: props.dialogId,
                    date: boatraceDate,
                  })
                "
              >
                更新
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal_button {
  width: 8em;
}
</style>
